export default __webpack_public_path__ + "static/media/shelf.37a3d2e4.JPG";